import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PATCH_DONE_WORKS_CONTROL_METRIC]: {
		url:'/company/:companyId/done_works/:doneWorkId/control_metrics/:controlMetricId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PATCH_DONE_WORKS_CONTROL_METRIC_BULK_UPDATE]: {
		url:'/company/:companyId/done_works/:doneWorkId/control_metrics/bulk_update',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRICS]: {
		url:'/company/:companyId/done_works/:doneWorkId/control_metrics/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/control_metrics/:controlMetricId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/control_metrics/:controlMetricId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].GET_DONE_WORKS_CONTROL_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/control_metrics/:controlMetricId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].CREATE_DONE_WORKS_CONTROL_METRIC]: {
		url:'/company/:companyId/done_works/:doneWorkId/control_metrics/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].PUT_DONE_WORKS_CONTROL_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/control_metrics/:controlMetricId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_CONTROL_METRICS].DELETE_DONE_WORKS_CONTROL_METRIC]: {
		url: '/company/:companyId/done_works/:doneWorkId/control_metrics/:controlMetricId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}